export function u128ToAscii(nameU128: string): string {
  // Remove the "u128" suffix and parse the remaining string as a number
  const numericValue = BigInt(nameU128.trimEnd().slice(0, -4));

  // Convert the number to a string by interpreting it as ASCII
  let asciiString = '';
  let tempValue = numericValue;

  while (tempValue > 0) {
    // Get the last 8 bits (1 byte) and convert to character
    const charCode = Number(tempValue & BigInt(0xff));
    asciiString = String.fromCharCode(charCode) + asciiString;

    // Shift right by 8 bits to process the next byte
    tempValue >>= BigInt(8);
  }

  return asciiString;
}

export function asciiToU128(asciiString: string): string {
  let numericValue = BigInt(0);

  for (let i = 0; i < asciiString.length; i++) {
    // Shift the current numeric value left by 8 bits to make room for the new byte
    numericValue =
      (numericValue << BigInt(8)) | BigInt(asciiString.charCodeAt(i));
  }

  // Convert the BigInt to a string and append "u128"
  return numericValue.toString() + 'u128';
}
